/* eslint class-methods-use-this: off */

import { AUTH_URL, LOGIN_URL, TOKEN_REQUEST_URL } from '../../constants/constants';
import BaseAuthUrls from './BaseAuthUrl';

/**
 * Utilities for building Classic CLoud Auth URLs and Functions.
 */
export default class ClassicCloudAuthUrls extends BaseAuthUrls {
  getIdP(): string {
    return AUTH_URL;
  }

  getLoginUrl(): string {
    return LOGIN_URL;
  }

  getLogoutUrl(): string {
    const classLogoutUrl: string = [
      AUTH_URL,
      '/identity/connect/endsession',
      `?id_token_hint=${this.getAuthIdToken()}`,
      `&post_logout_redirect_uri=${this.getLoginUrl()}`,
    ].join('');

    return classLogoutUrl;
  }

  getTokenRequestUrl(): string {
    return TOKEN_REQUEST_URL;
  }
}
